import React, { ReactElement } from 'react';
import { ModalDialogueContext, ModalDialogueWindow } from 'idsk-react-components';
import { HelmetProvider } from 'react-helmet-async';
import { ResponsiveContext } from 'slovlex-idsk-react-components';
import { SuccessMessageContextProvider } from './context/SuccessMessageContext';
import VestnikyRouter from './routing/VestnikyRouter';
import { ClientStatusContextProvider } from './context/ClientStatusContext';
import { SecurityContextProvider } from './context/SecurityContext';
import { UserContextProvider } from './context/UserContext';
import './main.scss';

const App = (): ReactElement => (
  <ModalDialogueContext>
    <SuccessMessageContextProvider>
      <SecurityContextProvider>
        <ResponsiveContext maxDesktopValuePx={640}>
          <ClientStatusContextProvider>
            <ModalDialogueWindow />
            <UserContextProvider>
              <HelmetProvider>
                <VestnikyRouter />
              </HelmetProvider>
            </UserContextProvider>
          </ClientStatusContextProvider>
        </ResponsiveContext>
      </SecurityContextProvider>
    </SuccessMessageContextProvider>
  </ModalDialogueContext>
);

export default App;
